import React, { useState, useEffect } from "react";
import useVisible from "../../hooks/useVisible.jsx";
import getMetadaAdobe from "../../utils/buttons/getMetadaAdobe";
import { getCachedScript } from "../../utils/scriptCache.js";

function SplitTemplate({ selectedTag, buttonTags, generateButtonTags }) {
  const [isVisible, setIsVisible] = useVisible("SplitTemplateVisibility");
  const [selectedCategory, setSelectedCategory] = useVisible(
    "SplitTemplateCategory",
  );
  const [fileExtension, setFileExtension] = useVisible(
    "SplitTemplateFileExtension",
  );
  const [partsSuffix, setPartsSuffix] = useVisible(
    "SplitTemplateFilePartsSuffix",
  );
  const [parts, setParts] = useVisible("SplitTemplateParts");
  const [tutorial, setTutorial] = useVisible("SplitTemplateTutorial");
  const [videoPreview, setVideoPreview] = useVisible(
    "SplitTemplateVideoPreview",
  );
  const [metadata, setMetadata] = useVisible("SplitTemplateMetadata");
  const [thumbnail, setThumbnail] = useVisible("SplitTemplateThumbnail");
  const [collectFiles, setCollectFiles] = useState(true);
  const [stock, setStock] = useVisible("SplitTemplateStock");
  const [userParts, setUserParts] = useState(
    localStorage.getItem("SplitTemplateUserParts") || 2,
  );
  const [transparent, setTransparent] = useVisible(
    "vbTransparentSplitTemplate",
  );

  // сразу под импортами, до объявления компонента
  const categoryOptions = [
    { label: "Backgrounds", id: 10 },
    { label: "Infographics", id: 11 },
    { label: "Logo Reveals", id: 26 },
    { label: "Lower Thirds", id: 7 },
    { label: "Motion Effects", id: 30 },
    { label: "Motion Overlays", id: 31 },
    { label: "Slideshows", id: 38 },
    { label: "Titles", id: 40 },
    { label: "Transitions", id: 9 },
  ];

  const handleClick = (script, argument) => {
    getCachedScript();
    window.jsx.evalScript(
      `run(${script}(${JSON.stringify(argument)}));`,
      function (result) {
        if (result) {
          if (stock === "adobe" && script.includes("Metadata")) {
            const data = JSON.parse(result);
            const names = data.names.map((item) => item.name);
            data.selectedCategory = selectedCategory;
            const prompt = `You will be given a list of project names typically used for stock video templates on marketplaces like Videohive or MotionArray.
Your task:
- For each name, generate a list of at least 20 relevant stock keywords (in English).
- Ignore numeric suffixes (like 01, 02, Part 1, Vol. 2, etc.).
- If multiple names share the same base name and differ only by numbering, return the same keyword list for all of them.
- Keywords should reflect the project's type, style, theme, and purpose.
- Do not include any text, code blocks, markdown formatting, or explanations.
- Only return a raw JSON array of keyword arrays, like:
[["keyword1", "keyword2", ...], ["keyword1", "keyword2", ...]]
Names:${JSON.stringify(names)}`;

            getMetadaAdobe(data, prompt);
          }
        }
      },
    );
  };
  const handleStockChange = (event) => {
    setStock(event.target.value);
    console.log("Stock selected:", event.target.value);
  };

  const handleSuffixChange = (event) => {
    setPartsSuffix(event.target.value);
    console.log("Parts suffix:", event.target.value);
  };

  if (selectedTag && !buttonTags.includes(selectedTag)) {
    return null;
  }

  return (
    <>
      <li
        onClick={() => setIsVisible(!isVisible)}
        className={`button-card resolution-toggle ${isVisible ? "active" : ""}`}
      >
        <div className="button-card__icon">
          <i class="fa-sharp fa-regular fa-columns-3"></i>
        </div>
        <div className="button-card__title">Split Template</div>
        {generateButtonTags()}
      </li>
      <div
        className={`render-group ${isVisible ? "" : "render-group--hidden"}`}
      >
        <div className="render-group__checkbox-group">
          {stock === "videobolt" && (
            <div className="render-group__checkbox">
              <input
                type="checkbox"
                id="vbTransparent"
                checked={transparent}
                onChange={() => setTransparent(!transparent)}
                className="hidden-checkbox"
              />
              <label htmlFor="vbTransparent">
                <span className="custom-checkbox"></span>
                <span className="label-text">Transparent</span>
              </label>
            </div>
          )}
          <div className="render-group__checkbox">
            <input
              type="checkbox"
              id="parts"
              checked={parts}
              onChange={() => {
                setParts(!parts);
              }}
              className="hidden-checkbox"
            />
            <label htmlFor="parts">
              <span className="custom-checkbox"></span>
              <span className="label-text">User Parts</span>
            </label>
          </div>
          {collectFiles && (
            <div className="render-group__dropdown">
              <span className="render-group__dropdown-text">Stock</span>
              <select value={stock} onChange={handleStockChange}>
                <option value=" ">Classic</option>
                <option value="videobolt">Videobolt</option>
                <option value="adobe">Adobe Stock</option>
              </select>
            </div>
          )}

          {collectFiles && stock === "adobe" && (
            <div className="render-group__dropdown">
              <span className="render-group__dropdown-text">Category</span>
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
              >
                {categoryOptions.map(({ label, id }) => (
                  <option key={id} value={id}>
                    {label}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="render-group__dropdown">
            <span className="render-group__dropdown-text">Add To The Name</span>
            <select value={partsSuffix} onChange={handleSuffixChange}>
              <option value=" ">None</option>
              <option value=" Part ">Part</option>
              <option value=" Vol.">Vol.</option>
              <option value=" Slide ">Slide</option>
            </select>
          </div>

          {parts && (
            <div className="rename__input-group">
              <span className="render-group__dropdown-text">Set Parts</span>
              <input
                className="rename__input"
                type="number"
                value={userParts}
                onChange={(e) => setUserParts(e.target.value)}
                onBlur={() => {
                  if (Number(userParts) < 2) {
                    setUserParts(2);
                  }
                }}
                placeholder="Parts"
                min="2"
              />
            </div>
          )}
        </div>

        <div className="render-group__tools-grid">
          <div
            onClick={() =>
              handleClick("splitTemplate", {
                userParts: !parts ? false : userParts,
                fileExtension: stock === "adobe" ? true : false,
                partsSuffix: partsSuffix,
                collectFiles: collectFiles,
                stock: stock,
              })
            }
            className="render-group__button"
          >
            <i class="fa-solid fa-scissors"></i>
            <span className="render-group__button-text">Split</span>
          </div>

          {!parts && (
            <>
              {stock !== "videobolt" && (
                <>
                  <div
                    onClick={() =>
                      handleClick("exportMediaPreviewSplitTemplate", {
                        exportType: "thumbnail",
                        userParts: !parts ? false : userParts,
                        partsSuffix: partsSuffix,
                        collectFiles: collectFiles,
                        stock: stock,
                      })
                    }
                    className="render-group__button"
                  >
                    <i class="fa-sharp fa-regular fa-image"></i>
                    <span className="render-group__button-text">Thumbnail</span>
                  </div>
                  <div
                    onClick={() =>
                      handleClick("exportMediaPreviewSplitTemplate", {
                        exportType: "video",
                        userParts: !parts ? false : userParts,
                        partsSuffix: partsSuffix,
                        collectFiles: collectFiles,
                        stock: stock,
                      })
                    }
                    className="render-group__button"
                  >
                    <i class="fa-sharp fa-light fa-film"></i>
                    <span className="render-group__button-text">Preview</span>
                  </div>
                  <div
                    onClick={() =>
                      handleClick("createSplitTemplateTutorial", {
                        userParts: !parts ? false : userParts,
                        partsSuffix: partsSuffix,
                        collectFiles: collectFiles,
                        stock: stock,
                      })
                    }
                    className="render-group__button"
                  >
                    <i class="fa-sharp fa-regular fa-comment-text"></i>
                    <span className="render-group__button-text">Tutorial</span>
                  </div>
                </>
              )}
              {stock !== " " && (
                <div
                  onClick={() =>
                    handleClick("exportSplitTemplateMetadata", {
                      userParts: !parts ? false : userParts,
                      fileExtension: stock === "adobe" ? true : false,
                      partsSuffix: partsSuffix,
                      collectFiles: collectFiles,
                      stock: stock,
                      splitTemplate: true,
                      transparent: transparent,
                    })
                  }
                  className="render-group__button"
                >
                  <i class="fa-light fa-database"></i>
                  <span className="render-group__button-text">Metadata</span>
                </div>
              )}
              <div
                onClick={() =>
                  handleClick("createZipSplitTemplate", {
                    userParts: !parts ? false : userParts,
                    fileExtension: stock === "adobe" ? true : false,
                    partsSuffix: partsSuffix,
                    collectFiles: collectFiles,
                    stock: stock,
                  })
                }
                className="render-group__button"
              >
                <i class="fa-sharp fa-light fa-file-zip"></i>
                <span className="render-group__button-text">Zip</span>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default SplitTemplate;
